export default __webpack_public_path__ + "static/media/pg-5.47907e3c.jpg";